// extracted by mini-css-extract-plugin
module.exports = {"content-area":"content-area_content-area__3Er_G","is-hero":"content-area_is-hero__YfnYJ"};